<template>
    <div class="step step--7">
        <div class="step__container">

            <!-- Title -->
            <div class="step__title" ref="title">
                <p>Let’s add more contacts for your loved one to call.</p>
            </div>

            <!-- Subtitle -->
            <div class="step__subtitle" ref="subtitle">
                <p>Optional</p>
            </div>

            <!-- Form -->
            <div class="step__form" ref="form">
                <div v-for="(contact, index) in contacts" class="step__form-block" :key="index">

                    <!-- Name Part -->
                    <InputField
                        title="NAME"
                        type="text"
                        placeholder="Name"
                        autocomplete=""
                        v-model="contact.name"
                        :disabled="false"
                        :errored="false"
                        :validated="nameValid(contact.name)"
                        errorMessage=""
                    ></InputField>
                    

                    <!-- Number Part -->
                    <InputField
                        title="MOBILE NUMBER"
                        type="tel"
                        placeholder="(123) 456-7890"
                        autocomplete="mobile tel"
                        v-model="contact.phone"
                        :disabled="false"
                        :errored="false"
                        :validated="numberValid(contact.phone)"
                        errorMessage=""
                        mask="(###) ###-####"
                    ></InputField>

                </div>
            </div>

            <!-- Add Another Contact Button -->
            <a @click.prevent="addContactForm" class="step__add" ref="addButton">
                <span class="step__add-info">
                    <span class="step__add-icon"><plusIcon></plusIcon></span>
                    <span class="step__add-name">add another contact</span>
                </span>
            </a>
            
            <!-- Next Button -->
            <div class="step__button" ref="button">
                <a href="#" @click.prevent="goNextStep"
                   class="button">
                    <span>Next</span>
                </a>
            </div>

        </div>
    </div>
</template>

<script>

    import InputField from "@/components/1-common/InputField";
    import checkWhiteIcon from '@/assets/svg/check-white.svg';
    import plusIcon from '@/assets/svg/plus.svg';
    import { TimelineMax } from 'gsap';
    import { contactsCollection, usersCollection } from '../../tools/firebaseConfig';

    let tl = new TimelineMax({
        delay: 1
    });

    export default {
        name: 'Step4_AddContacts',
        data() {
            return {
                contacts: [
                    {
                        name: '',
                        phone: ''
                    }
                ]
            }
        },
        watch: {
            contacts: function (val) {
                
                const data = {
                    field: 'contacts',
                    new_value: val
                }
                amplitude.getInstance().logEvent('input_changed', data);
            }
        },
        components: {
            InputField,
            checkWhiteIcon,
            plusIcon
        },
        methods: {

            nameValid(name) {
                if (name.trim().length == 0) { return false; }
                return name.length >= 2;
            },
            numberValid(number) {
                return number.length == 14;
            },

            unmask(val) {
                return val.replace(/\D+/g, '');
            },

            goNextStep() {
                
                // Filters out invalid contacts
                const validContacts = this.contacts.filter(contact => {
                    return this.nameValid(contact.name) && this.numberValid(contact.phone)
                })
                
                // If no valid contacts, skip
                if (validContacts.length == 0) {
                    this.$emit('nextStep');
                    return;
                }
                

                this.$emit('showLoading');
                
                var newContactIds = []

                const contactPromises = validContacts.map(contact => {
                    
                    return contactsCollection.push().then(newRef => {

                        const unmaskedNumber = this.unmask(contact.phone);
                        const formattedNumber = '+1' + unmaskedNumber;

                        const newContactModel = {
                            'country': 'US',
                            'id': newRef.key,
                            'name': contact.name,
                            'profileImageUrl': 'https://firebasestorage.googleapis.com/v0/b/ohana-4dd34.appspot.com/o/UserImages%2F1QLXou9TplUYJA8IMJMtGckWelr1%2FprofilePicture?alt=media&token=8d19e65c-eb72-4633-ab16-4f99a0d10778',
                            'phone': formattedNumber
                        }

                        newContactIds.push(newRef.key);

                        return newRef.set(newContactModel)
                        .catch(error => {
                            console.log('error setting contact:');
                            console.log(error);
                        })
                    })
                })

                Promise.all(contactPromises)
                .then(completeContacts => {
                    
                    console.log('all contacts set');
                    console.log(newContactIds);

                    const userModelPromises = newContactIds.map(newContactId => {
                        
                        // Add contact to user model
                        return usersCollection.child(this.$parent.currentUid).child('contacts').child(newContactId).set('0')
                        .catch(error => {
                            console.log('error updating the user model:')
                            console.log(error)
                        })
                    })

                    Promise.all(userModelPromises)
                    .then(completedUserModels => {

                        this.$emit('dismissLoading');
                        this.$emit('nextStep');
                    })
                })
            },

            addContactForm() {
                this.contacts.push({
                    name: '',
                    phone: ''
                })
            }
        },
        mounted() {
            
            amplitude.getInstance().logEvent('signup_page_addcontacts_loaded');

            const {title, subtitle, form, button, addButton} = this.$refs;
            tl
            .from([title, subtitle], 1.2, {autoAlpha: 0, ease: Power2.easeOut})
            .from(form, 1.2, {autoAlpha: 0, ease: Power2.easeOut}, "-=.8")
            .from(addButton, 1.2, {scale: .9, autoAlpha: 0, ease: Power2.easeOut}, "-=.8")
            .from(button, 1.2, {scale: .9, autoAlpha: 0, ease: Power2.easeOut}, "-=.8")
        }
    }
</script>




// WEBPACK FOOTER //
// Step4_AddContacts.vue?13cdb2b0